import {callAPI} from '@/store/utils'; // eslint-disable-line
import {base} from './utils';

// Chart of accounts (ledger_account). GET returns a tree: an array of root
// accounts, each carrying a `children` array of its auxiliary sub-accounts.
// Composed into the `accounting` namespace by ./index.js. Mutating actions
// return the raw response and let the screen re-fetch the tree, since partial
// tree patching is not worth the complexity here.
export default {
  state: {
    // Tree as returned by GET /ledger-accounts (roots with nested children).
    ledgerAccounts: [],
    ledgerAccountsLoaded: false,
  },
  getters: {
    ledgerAccounts: (state) => state.ledgerAccounts,
    ledgerAccountsLoaded: (state) => state.ledgerAccountsLoaded,
  },
  mutations: {
    setLedgerAccounts(state, tree) {
      state.ledgerAccounts = tree || [];
      state.ledgerAccountsLoaded = true;
    },
  },
  actions: {
    async actionGetLedgerAccounts({commit}) {
      const res = await callAPI('GET', `${base()}/ledger-accounts`);
      if (res && !res.error) commit('setLedgerAccounts', res.result);
      return res;
    },
    // body: { account_number (req), label?, parent_account_id?, counterparty_id?,
    // bank_account_id?, is_active?=true }
    async actionCreateLedgerAccount(_ctx, body) {
      // Client-generated id (app convention).
      return callAPI('POST', `${base()}/ledger-accounts`, {
        id: window.utils.genId(),
        ...body,
      });
    },
    // body: { label?, is_active?, counterparty_id?, bank_account_id? }
    async actionUpdateLedgerAccount(_ctx, {id, ...body}) {
      return callAPI('PATCH', `${base()}/ledger-accounts/${id}`, body);
    },
    async actionArchiveLedgerAccount(_ctx, {id}) {
      return callAPI('POST', `${base()}/ledger-accounts/${id}/archive`);
    },
    async actionRestoreLedgerAccount(_ctx, {id}) {
      return callAPI('POST', `${base()}/ledger-accounts/${id}/restore`);
    },
    // payload: FormData with a `file` field (.csv/.xlsx), or {accounts:[...]}.
    // Result: { created, errors:[{row, account_number, reason}] }.
    async actionImportLedgerAccounts(_ctx, payload) {
      return callAPI('POST', `${base()}/ledger-accounts/import`, payload);
    },
    // Seeds the editable PCG starter. Same { created, errors } shape; skips
    // numbers that already exist.
    async actionSeedDefaultLedgerAccounts() {
      return callAPI('POST', `${base()}/ledger-accounts/seed-default`);
    },
  },
};
